import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'onlyletters'})
export class OnlyLettersPipe implements PipeTransform {
  /**
   * @param {string} value the input value
   * @returns {string} The same string but with non-letters removed
   */
  public transform(value: string): string {
    return value.replace(/[^a-z]/gi, '');
  }
}
